import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPopsicle1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPopsicle1"><Path fillRule="evenodd" clipRule="evenodd" d="M5 4.75C5 2.67893 6.67893 1 8.75 1H15.25C17.3211 1 19 2.67893 19 4.75V18H14.5V20.5C14.5 21.8807 13.3807 23 12 23C10.6193 23 9.5 21.8807 9.5 20.5V18H5V4.75ZM11 18V20.5C11 21.0523 11.4477 21.5 12 21.5C12.5523 21.5 13 21.0523 13 20.5V18H11ZM10.5 6H9V13H10.5V6ZM15 6V13H13.5V6H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPopsicle1;
